export const PLACEHOLDER_DIMENSIONS = {
    mainTextHeight: 36,
    mainTextCornerRadius: 32,
    iconWidth: 20,
    iconHeight: 20,
    textWidth: 122,
    textHeight: 12,
    textCornerRadius: 2,
    smallTextWidth: 67,
    smallTextHeight: 16,
    smallTextCornerRadius: 4,
};
